import * as ambassadorWixLoyaltyV1Account from './loyalty-v1-account-accounts.http.js';
import * as ambassadorWixLoyaltyV1AccountTypes from './loyalty-v1-account-accounts.types.js';
import * as ambassadorWixLoyaltyV1AccountUniversalTypes from './loyalty-v1-account-accounts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createAccount(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.CreateAccountRequest,
  ambassadorWixLoyaltyV1AccountTypes.CreateAccountRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.CreateAccountResponse,
  ambassadorWixLoyaltyV1AccountTypes.CreateAccountResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.createAccount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function earnPoints(): __PublicMethodMetaInfo<
  'POST',
  { accountId: string },
  ambassadorWixLoyaltyV1AccountUniversalTypes.EarnPointsRequest,
  ambassadorWixLoyaltyV1AccountTypes.EarnPointsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.EarnPointsResponse,
  ambassadorWixLoyaltyV1AccountTypes.EarnPointsResponse
> {
  const payload = { accountId: ':accountId' } as any;

  const getRequestOptions = ambassadorWixLoyaltyV1Account.earnPoints(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/{accountId}/earn-points',
    pathParams: { accountId: 'accountId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function adjustPoints(): __PublicMethodMetaInfo<
  'POST',
  { accountId: string },
  ambassadorWixLoyaltyV1AccountUniversalTypes.AdjustPointsRequest,
  ambassadorWixLoyaltyV1AccountTypes.AdjustPointsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.AdjustPointsResponse,
  ambassadorWixLoyaltyV1AccountTypes.AdjustPointsResponse
> {
  const payload = { accountId: ':accountId' } as any;

  const getRequestOptions = ambassadorWixLoyaltyV1Account.adjustPoints(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/{accountId}/adjust-points',
    pathParams: { accountId: 'accountId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAccount(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetAccountRequest,
  ambassadorWixLoyaltyV1AccountTypes.GetAccountRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetAccountResponse,
  ambassadorWixLoyaltyV1AccountTypes.GetAccountResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions = ambassadorWixLoyaltyV1Account.getAccount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accounts/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryLoyaltyAccounts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.QueryLoyaltyAccountsRequest,
  ambassadorWixLoyaltyV1AccountTypes.QueryLoyaltyAccountsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.QueryLoyaltyAccountsResponse,
  ambassadorWixLoyaltyV1AccountTypes.QueryLoyaltyAccountsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.queryLoyaltyAccounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getProgramTotals(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetProgramTotalsRequest,
  ambassadorWixLoyaltyV1AccountTypes.GetProgramTotalsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetProgramTotalsResponse,
  ambassadorWixLoyaltyV1AccountTypes.GetProgramTotalsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.getProgramTotals(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accounts/program-totals',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCurrentMemberAccount(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetCurrentMemberAccountRequest,
  ambassadorWixLoyaltyV1AccountTypes.GetCurrentMemberAccountRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetCurrentMemberAccountResponse,
  ambassadorWixLoyaltyV1AccountTypes.GetCurrentMemberAccountResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.getCurrentMemberAccount(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accounts/my-account',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getAccountBySecondaryId(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetAccountBySecondaryIdRequest,
  ambassadorWixLoyaltyV1AccountTypes.GetAccountBySecondaryIdRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.GetAccountBySecondaryIdResponse,
  ambassadorWixLoyaltyV1AccountTypes.GetAccountBySecondaryIdResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.getAccountBySecondaryId(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accounts/fetch-by',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function listAccounts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.ListAccountsRequest,
  ambassadorWixLoyaltyV1AccountTypes.ListAccountsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.ListAccountsResponse,
  ambassadorWixLoyaltyV1AccountTypes.ListAccountsResponse
> {
  const payload = {} as any;

  const getRequestOptions = ambassadorWixLoyaltyV1Account.listAccounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/accounts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function searchAccounts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.SearchAccountsRequest,
  ambassadorWixLoyaltyV1AccountTypes.SearchAccountsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.SearchAccountsResponse,
  ambassadorWixLoyaltyV1AccountTypes.SearchAccountsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.searchAccounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/search',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function countAccounts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.CountAccountsRequest,
  ambassadorWixLoyaltyV1AccountTypes.CountAccountsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.CountAccountsResponse,
  ambassadorWixLoyaltyV1AccountTypes.CountAccountsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.countAccounts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/count',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkAdjustPoints(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixLoyaltyV1AccountUniversalTypes.BulkAdjustPointsRequest,
  ambassadorWixLoyaltyV1AccountTypes.BulkAdjustPointsRequest,
  ambassadorWixLoyaltyV1AccountUniversalTypes.BulkAdjustPointsResponse,
  ambassadorWixLoyaltyV1AccountTypes.BulkAdjustPointsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixLoyaltyV1Account.bulkAdjustPoints(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/accounts/bulk-adjust',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  LoyaltyAccount as LoyaltyAccountOriginal,
  Points as PointsOriginal,
  Tier as TierOriginal,
  Contact as ContactOriginal,
  Image as ImageOriginal,
  PointsExpiration as PointsExpirationOriginal,
  RewardAvailabilityUpdated as RewardAvailabilityUpdatedOriginal,
  UpdateTrigger as UpdateTriggerOriginal,
  UpdateTriggerWithLiterals as UpdateTriggerWithLiteralsOriginal,
  CreateAccountRequest as CreateAccountRequestOriginal,
  CreateAccountResponse as CreateAccountResponseOriginal,
  EarnPointsRequest as EarnPointsRequestOriginal,
  EarnPointsRequestActivityDetailsOneOf as EarnPointsRequestActivityDetailsOneOfOriginal,
  FollowedSocialMedia as FollowedSocialMediaOriginal,
  EarnPointsResponse as EarnPointsResponseOriginal,
  PointsUpdated as PointsUpdatedOriginal,
  FirstTransaction as FirstTransactionOriginal,
  AdjustPointsRequest as AdjustPointsRequestOriginal,
  AdjustPointsRequestTypeOneOf as AdjustPointsRequestTypeOneOfOriginal,
  AdjustPointsResponse as AdjustPointsResponseOriginal,
  DeductPointsRequest as DeductPointsRequestOriginal,
  DeductPointsResponse as DeductPointsResponseOriginal,
  RedeemPointsRequest as RedeemPointsRequestOriginal,
  RedeemPointsResponse as RedeemPointsResponseOriginal,
  RedeemDeterminedAmountOfPointsRequest as RedeemDeterminedAmountOfPointsRequestOriginal,
  RedeemDeterminedAmountOfPointsResponse as RedeemDeterminedAmountOfPointsResponseOriginal,
  RefundTransactionRequest as RefundTransactionRequestOriginal,
  RefundTransactionResponse as RefundTransactionResponseOriginal,
  GetAccountRequest as GetAccountRequestOriginal,
  GetAccountResponse as GetAccountResponseOriginal,
  QueryLoyaltyAccountsRequest as QueryLoyaltyAccountsRequestOriginal,
  CursorQuery as CursorQueryOriginal,
  CursorQueryPagingMethodOneOf as CursorQueryPagingMethodOneOfOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  CursorPaging as CursorPagingOriginal,
  QueryLoyaltyAccountsResponse as QueryLoyaltyAccountsResponseOriginal,
  CursorPagingMetadata as CursorPagingMetadataOriginal,
  Cursors as CursorsOriginal,
  ListUserAccountsRequest as ListUserAccountsRequestOriginal,
  ListUserAccountsResponse as ListUserAccountsResponseOriginal,
  LoyaltyAccountForMetaSite as LoyaltyAccountForMetaSiteOriginal,
  GetProgramTotalsRequest as GetProgramTotalsRequestOriginal,
  GetProgramTotalsResponse as GetProgramTotalsResponseOriginal,
  TierTotal as TierTotalOriginal,
  GetCurrentMemberAccountRequest as GetCurrentMemberAccountRequestOriginal,
  GetCurrentMemberAccountResponse as GetCurrentMemberAccountResponseOriginal,
  GetAccountBySecondaryIdRequest as GetAccountBySecondaryIdRequestOriginal,
  GetAccountBySecondaryIdRequestIdOneOf as GetAccountBySecondaryIdRequestIdOneOfOriginal,
  GetAccountBySecondaryIdResponse as GetAccountBySecondaryIdResponseOriginal,
  ListAccountsRequest as ListAccountsRequestOriginal,
  ListAccountsResponse as ListAccountsResponseOriginal,
  PagingMetadataV2 as PagingMetadataV2Original,
  SearchAccountsRequest as SearchAccountsRequestOriginal,
  CursorSearch as CursorSearchOriginal,
  CursorSearchPagingMethodOneOf as CursorSearchPagingMethodOneOfOriginal,
  Aggregation as AggregationOriginal,
  AggregationKindOneOf as AggregationKindOneOfOriginal,
  RangeBucket as RangeBucketOriginal,
  SortType as SortTypeOriginal,
  SortTypeWithLiterals as SortTypeWithLiteralsOriginal,
  SortDirection as SortDirectionOriginal,
  SortDirectionWithLiterals as SortDirectionWithLiteralsOriginal,
  MissingValues as MissingValuesOriginal,
  MissingValuesWithLiterals as MissingValuesWithLiteralsOriginal,
  IncludeMissingValuesOptions as IncludeMissingValuesOptionsOriginal,
  ScalarType as ScalarTypeOriginal,
  ScalarTypeWithLiterals as ScalarTypeWithLiteralsOriginal,
  ValueAggregation as ValueAggregationOriginal,
  ValueAggregationOptionsOneOf as ValueAggregationOptionsOneOfOriginal,
  NestedAggregationType as NestedAggregationTypeOriginal,
  NestedAggregationTypeWithLiterals as NestedAggregationTypeWithLiteralsOriginal,
  RangeAggregation as RangeAggregationOriginal,
  ScalarAggregation as ScalarAggregationOriginal,
  DateHistogramAggregation as DateHistogramAggregationOriginal,
  DateHistogramAggregationInterval as DateHistogramAggregationIntervalOriginal,
  DateHistogramAggregationIntervalWithLiterals as DateHistogramAggregationIntervalWithLiteralsOriginal,
  NestedAggregationItem as NestedAggregationItemOriginal,
  NestedAggregationItemKindOneOf as NestedAggregationItemKindOneOfOriginal,
  AggregationType as AggregationTypeOriginal,
  AggregationTypeWithLiterals as AggregationTypeWithLiteralsOriginal,
  NestedAggregation as NestedAggregationOriginal,
  GroupByAggregation as GroupByAggregationOriginal,
  GroupByAggregationKindOneOf as GroupByAggregationKindOneOfOriginal,
  SearchDetails as SearchDetailsOriginal,
  Mode as ModeOriginal,
  ModeWithLiterals as ModeWithLiteralsOriginal,
  SearchAccountsResponse as SearchAccountsResponseOriginal,
  AggregationData as AggregationDataOriginal,
  ValueAggregationResult as ValueAggregationResultOriginal,
  RangeAggregationResult as RangeAggregationResultOriginal,
  NestedAggregationResults as NestedAggregationResultsOriginal,
  NestedAggregationResultsResultOneOf as NestedAggregationResultsResultOneOfOriginal,
  ValueResults as ValueResultsOriginal,
  RangeResults as RangeResultsOriginal,
  AggregationResultsScalarResult as AggregationResultsScalarResultOriginal,
  NestedValueAggregationResult as NestedValueAggregationResultOriginal,
  ValueResult as ValueResultOriginal,
  RangeResult as RangeResultOriginal,
  ScalarResult as ScalarResultOriginal,
  ScalarDateResult as ScalarDateResultOriginal,
  NestedResultValue as NestedResultValueOriginal,
  NestedResultValueResultOneOf as NestedResultValueResultOneOfOriginal,
  Results as ResultsOriginal,
  DateHistogramResult as DateHistogramResultOriginal,
  GroupByValueResults as GroupByValueResultsOriginal,
  DateHistogramResults as DateHistogramResultsOriginal,
  NestedResults as NestedResultsOriginal,
  AggregationResultsScalarDateResult as AggregationResultsScalarDateResultOriginal,
  AggregationResults as AggregationResultsOriginal,
  AggregationResultsResultOneOf as AggregationResultsResultOneOfOriginal,
  ExportAccountsRequest as ExportAccountsRequestOriginal,
  QueryV2 as QueryV2Original,
  QueryV2PagingMethodOneOf as QueryV2PagingMethodOneOfOriginal,
  Paging as PagingOriginal,
  ExportAccountsResponse as ExportAccountsResponseOriginal,
  CountAccountsRequest as CountAccountsRequestOriginal,
  CountAccountsResponse as CountAccountsResponseOriginal,
  BulkAdjustPointsRequest as BulkAdjustPointsRequestOriginal,
  BulkAdjustPointsRequestTypeOneOf as BulkAdjustPointsRequestTypeOneOfOriginal,
  BulkAdjustPointsResponse as BulkAdjustPointsResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  Empty as EmptyOriginal,
  TiersRollingUpdate as TiersRollingUpdateOriginal,
  TiersProgramSettingsChanged as TiersProgramSettingsChangedOriginal,
  TiersProgramSettings as TiersProgramSettingsOriginal,
  TiersProgramSettingsPeriodOneOf as TiersProgramSettingsPeriodOneOfOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  TierDefinition as TierDefinitionOriginal,
  CommonImage as CommonImageOriginal,
  FocalPoint as FocalPointOriginal,
  RollingWindow as RollingWindowOriginal,
  SubscriptionEvent as SubscriptionEventOriginal,
  SubscriptionEventEventOneOf as SubscriptionEventEventOneOfOriginal,
  SubscriptionCreated as SubscriptionCreatedOriginal,
  Subscription as SubscriptionOriginal,
  BillingReference as BillingReferenceOriginal,
  ProviderName as ProviderNameOriginal,
  ProviderNameWithLiterals as ProviderNameWithLiteralsOriginal,
  Cycle as CycleOriginal,
  CycleCycleSelectorOneOf as CycleCycleSelectorOneOfOriginal,
  Interval as IntervalOriginal,
  IntervalUnit as IntervalUnitOriginal,
  IntervalUnitWithLiterals as IntervalUnitWithLiteralsOriginal,
  OneTime as OneTimeOriginal,
  SubscriptionStatus as SubscriptionStatusOriginal,
  SubscriptionStatusWithLiterals as SubscriptionStatusWithLiteralsOriginal,
  ReactivationData as ReactivationDataOriginal,
  ReactivationReasonEnum as ReactivationReasonEnumOriginal,
  ReactivationReasonEnumWithLiterals as ReactivationReasonEnumWithLiteralsOriginal,
  SubscriptionAssigned as SubscriptionAssignedOriginal,
  SubscriptionCancelled as SubscriptionCancelledOriginal,
  CancellationDetails as CancellationDetailsOriginal,
  Initiator as InitiatorOriginal,
  InitiatorWithLiterals as InitiatorWithLiteralsOriginal,
  RefundType as RefundTypeOriginal,
  RefundTypeWithLiterals as RefundTypeWithLiteralsOriginal,
  SubscriptionAutoRenewTurnedOn as SubscriptionAutoRenewTurnedOnOriginal,
  SubscriptionAutoRenewTurnedOff as SubscriptionAutoRenewTurnedOffOriginal,
  SubscriptionUnassigned as SubscriptionUnassignedOriginal,
  UnassignReason as UnassignReasonOriginal,
  UnassignReasonWithLiterals as UnassignReasonWithLiteralsOriginal,
  SubscriptionTransferred as SubscriptionTransferredOriginal,
  RecurringChargeSucceeded as RecurringChargeSucceededOriginal,
  ContractSwitched as ContractSwitchedOriginal,
  ContractSwitchType as ContractSwitchTypeOriginal,
  ContractSwitchTypeWithLiterals as ContractSwitchTypeWithLiteralsOriginal,
  ContractSwitchReason as ContractSwitchReasonOriginal,
  ContractSwitchReasonWithLiterals as ContractSwitchReasonWithLiteralsOriginal,
  ProductPriceIncreaseData as ProductPriceIncreaseDataOriginal,
  PriceIncreaseTrigger as PriceIncreaseTriggerOriginal,
  PriceIncreaseTriggerWithLiterals as PriceIncreaseTriggerWithLiteralsOriginal,
  ProductAdjustment as ProductAdjustmentOriginal,
  ProductAdjustmentWithLiterals as ProductAdjustmentWithLiteralsOriginal,
  SubscriptionNearEndOfPeriod as SubscriptionNearEndOfPeriodOriginal,
  SubscriptionPendingChange as SubscriptionPendingChangeOriginal,
  RecurringChargeAttemptFailed as RecurringChargeAttemptFailedOriginal,
  SubscriptionUpdated as SubscriptionUpdatedOriginal,
  SubscriptionMigratedFromVista as SubscriptionMigratedFromVistaOriginal,
  SubscriptionVistaMigrationReverted as SubscriptionVistaMigrationRevertedOriginal,
  ContactSyncRequest as ContactSyncRequestOriginal,
  BulkUpsertAccountsRequest as BulkUpsertAccountsRequestOriginal,
  AccountToUpsert as AccountToUpsertOriginal,
  BulkUpsertAccountsResponse as BulkUpsertAccountsResponseOriginal,
  BulkAccountResult as BulkAccountResultOriginal,
  ItemMetadata as ItemMetadataOriginal,
  ApplicationError as ApplicationErrorOriginal,
  BulkActionMetadata as BulkActionMetadataOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './loyalty-v1-account-accounts.types.js';
